import { MessageContainer } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/MessagesList/MessagesList.styled';
import { Flex, Title, Text } from '@mantine/core';
import { EmailSentEventStatusResponse, InvestorMessagesRes } from '@dealstack/shared/lib/generated';
import { StatusWithIcon } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusWithIcon/StatusWithIcon';
import { INVESTOR_MESSAGES_TEST_ID } from '@dealstack/shared/tests/testElementIds';

interface Props {
	message?: InvestorMessagesRes['messages'][0];
	selected?: boolean;
	onSelect?: () => void;
	/** Index for E2E testing - used as data-testindex attribute */
	index?: number;
}

export const MessageListItem = ({ message, selected = false, onSelect, index }: Props) => {
	return (
		<MessageContainer
			data-testid={`${INVESTOR_MESSAGES_TEST_ID.MESSAGE_LIST_ITEM}`}
			data-testindex={index}
			p="0.5rem"
			borderRadius="0.25rem"
			direction="column"
			gap="xs"
			selected={selected}
			onClick={onSelect}
		>
			<Title
				order={6}
				fw={600}
				data-testid={INVESTOR_MESSAGES_TEST_ID.MESSAGE_LIST_ITEM_HEADER}
			>
				{message?.subject}
			</Title>
			<Text size="B6Medium">{message?.senderFullName}</Text>
			<Flex justify="space-between" gap={0} ml="0.25rem">
				<StatusWithIcon
					data-testid={INVESTOR_MESSAGES_TEST_ID.MESSAGE_LIST_ITEM_STATUS}
					status={message?.latestStatus ?? EmailSentEventStatusResponse.UNKNOWN}
				/>
				<Text fz={12}>{message?.sendDate || ''}</Text>
			</Flex>
		</MessageContainer>
	);
};
